import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'react-material-ui-carousel'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import CarouselImage from './CarouselImage'

import styles from './styles'

const ImageCarousel = (props) => {
  const { items } = props
  
  const classes = styles()
  
  return (
    <div className={classes.root}>
      <Carousel
        autoPlay={false}
        navButtonsAlwaysVisible={true}
        animation='slide'
      >
        {addKeyToObjectsArray(items).map((item) => (
          <CarouselImage key={item.key} item={item} />
        ))}
      </Carousel>
    </div>
  )
}

ImageCarousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      optimizedImageName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      alt: PropTypes.string,
      originalImageName: PropTypes.string.isRequired,
    }),
  ),
}

ImageCarousel.defaultProps = {
  items: [],
}

export default ImageCarousel
